import { format, getPattern, parse, validate } from '@philips-internal/oswald-ui-model/lib/formatters/date/date';
async function preventFutureDateAcceptNullValidate(value) {
    const currentDate = new Date();
    const minimumDate = new Date('1900-01-01');
    const valueDate = new Date(value);
    const validation = await validate(value);
    const isValidDate = validation[0].valid;
    const valid = ((valueDate <= currentDate && valueDate >= minimumDate && isValidDate) || value == null);
    return [{
            message: !valid ? 'results.validator.invalid-date' : '',
            name: 'prevent-future-accept-null-date',
            valid,
        }];
}
const PreventFutureDateAcceptNull = { format, parse, validate: preventFutureDateAcceptNullValidate, getPattern };
export default PreventFutureDateAcceptNull;
//# sourceMappingURL=prevent-future-date-accept-null.js.map